import {
    bodyConfig,
    dsplConfig,
    headingConfig,
    textConfig,
    component,
    typographyComponent,
    mergeConfig,
} from '@salutejs/plasma-new-hope/css';

import {
    configL as bodyConfigLCustom,
    configM as bodyConfigMCustom,
    configS as bodyConfigSCustom,
    configXS as bodyConfigXSCustom,
    configXXS as bodyConfigXXSCustom,
} from './Body.config';
import {
    configL as dsplConfigLCustom,
    configM as dsplConfigMCustom,
    configS as dsplConfigSCustom,
} from './Dspl.config';
import {
    configH1 as headingConfigH1Custom,
    configH2 as headingConfigH2Custom,
    configH3 as headingConfigH3Custom,
    configH4 as headingConfigH4Custom,
    configH5 as headingConfigH5Custom,
    configH6 as headingConfigH6Custom,
} from './Heading.config';
import {
    configL as textConfigLCustom,
    configM as textConfigMCustom,
    configS as textConfigSCustom,
    configXS as textConfigXSCustom,
    configSlim as textConfigSlimCustom,
} from './Text.config';

const bodyMConfig = mergeConfig(bodyConfig, bodyConfigMCustom);
const BodyMComponent = typographyComponent(component(bodyMConfig));

const bodyLConfig = mergeConfig(bodyConfig, bodyConfigLCustom);
const BodyLComponent = typographyComponent(component(bodyLConfig));

const bodySConfig = mergeConfig(bodyConfig, bodyConfigSCustom);
const BodySComponent = typographyComponent(component(bodySConfig));

const bodyXSConfig = mergeConfig(bodyConfig, bodyConfigXSCustom);
const BodyXSComponent = typographyComponent(component(bodyXSConfig));

const bodyXXSConfig = mergeConfig(bodyConfig, bodyConfigXXSCustom);
const BodyXXSComponent = typographyComponent(component(bodyXXSConfig));

const dsplMConfig = mergeConfig(dsplConfig, dsplConfigMCustom);
const DsplMComponent = typographyComponent(component(dsplMConfig));

const dsplLConfig = mergeConfig(dsplConfig, dsplConfigLCustom);
const DsplLComponent = typographyComponent(component(dsplLConfig));

const dsplSConfig = mergeConfig(dsplConfig, dsplConfigSCustom);
const DsplSComponent = typographyComponent(component(dsplSConfig));

const heading1Config = mergeConfig(headingConfig, headingConfigH1Custom);
const Heading1Component = typographyComponent(component(heading1Config));

const heading2Config = mergeConfig(headingConfig, headingConfigH2Custom);
const Heading2Component = typographyComponent(component(heading2Config));

const heading3Config = mergeConfig(headingConfig, headingConfigH3Custom);
const Heading3Component = typographyComponent(component(heading3Config));

const heading4Config = mergeConfig(headingConfig, headingConfigH4Custom);
const Heading4Component = typographyComponent(component(heading4Config));

const heading5Config = mergeConfig(headingConfig, headingConfigH5Custom);
const Heading5Component = typographyComponent(component(heading5Config));

const heading6Config = mergeConfig(headingConfig, headingConfigH6Custom);
const Heading6Component = typographyComponent(component(heading6Config));

const textMConfig = mergeConfig(textConfig, textConfigMCustom);
const TextMComponent = typographyComponent(component(textMConfig));

const textLConfig = mergeConfig(textConfig, textConfigLCustom);
const TextLComponent = typographyComponent(component(textLConfig));

const textSConfig = mergeConfig(textConfig, textConfigSCustom);
const TextSComponent = typographyComponent(component(textSConfig));

const textXSConfig = mergeConfig(textConfig, textConfigXSCustom);
const TextXSComponent = typographyComponent(component(textXSConfig));

const textSlimConfig = mergeConfig(textConfig, textConfigSlimCustom);
const TextSlimComponent = typographyComponent(component(textSlimConfig));

export const BodyM = BodyMComponent;
export const BodyL = BodyLComponent;
export const BodyS = BodySComponent;
export const BodyXS = BodyXSComponent;
export const BodyXXS = BodyXXSComponent;

export const DsplM = DsplMComponent;
export const DsplL = DsplLComponent;
export const DsplS = DsplSComponent;

export const H1 = Heading1Component;
export const H2 = Heading2Component;
export const H3 = Heading3Component;
export const H4 = Heading4Component;
export const H5 = Heading5Component;
export const H6 = Heading6Component;

export const TextM = TextMComponent;
export const TextL = TextLComponent;
export const TextS = TextSComponent;
export const TextXS = TextXSComponent;
export const TextSlim = TextSlimComponent;
